import script from "./similarGoods.vue?vue&type=script&lang=ts&setup=true"
export * from "./similarGoods.vue?vue&type=script&lang=ts&setup=true"

import "./similarGoods.vue?vue&type=style&index=0&id=2edca276&scoped=true&lang=scss"

import exportComponent from "D:\\otimes-en\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2edca276"]])

export default __exports__